import * as actions from "./actionsTypes";

const initialData = {
  loading: false,
  loadingById: false,
  saveLoading: false,
  factorQuestionsLength: 0,
  factorQuestions: [],
  factorQuestion: {},
  factorQuestionError: "",
  formError: "",
};

export default function FactorQuestionReducer(state = initialData,action) {
  switch (action.type) {
    case actions.LOADING_FACTOR_QUESTION:
      return { ...state, loading: action.payload };
    case actions.LOADING_FACTOR_QUESTION_BY_ID:
      return { ...state, loadingById: action.payload };
    case actions.SAVE_LOADING_FACTOR_QUESTION:
      return { ...state, saveLoading: action.payload };
    case actions.GET_FACTOR_QUESTION:
      return {
        ...state,
        factorQuestions: action.payload.factorQuestions,
        factorQuestionsLength: action.payload.factorQuestionsLength,
      };
    case actions.GET_FACTOR_QUESTION_BY_ID:
      return {
        ...state, factorQuestion: action.payload
      };
    case actions.FORM_FAIL:
      return { ...state, formError: action.payload };
    case actions.FACTOR_QUESTION_FAIL:
      return { ...state, factorQuestionError: action.payload };
    default:
      return state;
  }
}
